import script from "./VistoriaCard.vue?vue&type=script&setup=true&lang=js"
export * from "./VistoriaCard.vue?vue&type=script&setup=true&lang=js"

import "./VistoriaCard.vue?vue&type=style&index=0&id=79b99a54&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-79b99a54"]])

export default __exports__